import type { DeviceDto } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetDevices() {
	return useQuery({
		queryKey: ["devices"],
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/tokens/tokens`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch devices");
			}

			return (await res.json()) as DeviceDto[];
		},
	});
}
